<section>
  <header *ngIf="!noDelete">
    <img (click)="handleDelete()" src="./assets/icons/delete-branch.svg"/>
  </header>
  <ng-content></ng-content>
</section>